export default {"src":"/_next/static/media/floating-value-locked.97149950.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};